import Empty from "@/components/Empty.tsx";
import {Box, Stack, Typography, Chip, Button, Divider, useTheme} from '@mui/material'
import LoadMore from "@/components/LoadMore";
import RpIcon from "@/components/RpIcon";
import TransItem from "@/components/skeleton/TransItem";
import API from "@/constant/API";
import RouteConstant from "@/constant/RouteConstant";
import useLoadMore from "@/hook/useLoadMore";
import useRenders from "@/hook/useRenders";
import axiosInstance from "@/utils/axios";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import DayAssetsTransItem from "./DayAssetsTransItem";
import AssetsTransItem from "./AssetsTransItem.tsx";
import AssetsTransDetail from "./AssetsTransDetail";
import SearchItem from "@/pages/components/SearchItem"
import useSettings from "@/hook/useSettings";
import {useMemo, useRef} from "react";
import {groupBy} from 'es-toolkit/array';
import dayjs from 'dayjs';
import {useInfiniteScroll} from 'ahooks'
import classes from './index.module.css'
import PageBack from "@/components/PageBack";

import AssetsService from '@/services/assets'
import SimpleHeader from "@/pages/components/Headers/SimpleHeader";

interface Props {
  isCompact: boolean;
  bussinessType?: number;
  pageable?: boolean;
}

export default function AssetsTransactions({pageable, isCompact = false, bussinessType}) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme()
  const {
    settings,
  } = useSettings();

  const {renderDate} = useRenders();

  const ref = useRef(null);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [hasMore, setHasMore] = useState(false);
  const [current, setCurrent] = useState(null);
  const [search, setSearch] = useState(false);

  const [filters, setFilters] = useState([]);

  const _toTransList = () => {
    navigate(`${RouteConstant.ASSETS_TRANS_LIST}?bussinessType=${bussinessType}`);
  }

  const wrapperRef = useRef(null);

  const getList = async (pageNum: number, values: any) => {
    let res = await AssetsService.pendingDepositList({
      pageNum, pageSize: pageSize, ...values
    });

    const result = {
      list: res?.list || [],
      total: res?.total || 0,
      page: pageNum,
    };
    return result;
  }

  const getCompactList = async (pageNum: number) => {
    const res = await getList(1, {})
    return res?.list || []
  }

  const {data, loading, loadMore, loadingMore, noMore, reload, reloadAsync} = useInfiniteScroll((d) => {
    const page = d ? d.page + 1 : 1
    return getList(page, filters);
  }, {
    manual: true,
    target: isCompact ? null : ref,
    threshold: 300,
    isNoMore: (d) => {
      // d?.total <= d.list.length,
      return (d && d.list.length >= d.total)
    }
  });

  const handleSearch = (values) => {
    if (values.daysLasting === 'customize') {
      const startTime = renderDate(values.startTime)
      const endTime = renderDate(values.endTime)
      delete values.daysLasting;
      values = {...values, startTime, endTime};

    } else if (values.daysLasting === 'all') {
      values = {};
    } else {
      delete values.startTime;
      delete values.endTime;
    }
    setFilters(values)
    // loadMore(pageNum, pageSize, values);
    setSearch(false)
  }

  useEffect(() => {
    reloadAsync()
  }, [filters]);

  const list = useMemo(() => {
    if (!data) return [];
    return isCompact ? data.list.slice(0, 3) : data.list;
  }, [data]);

  const groupedList = useMemo(() => {
    const result = groupBy(list, (item) => {
      return dayjs(item.createTime).format('YYYYMMDD')
    })
    return result
  }, [list])

  return (
    <Stack className={classes.root}>
      <SimpleHeader title={t('deposit_list')}/>
      <Stack gap={'8px'} sx={{padding: '16px',marginTop:'24px'}} className="filters" direction="row">
        <Button
          sx={theme => ({
            backgroundColor: theme.palette.background.card,
            color: theme.palette.text.primary,
            borderRadius: '16px',
          })}
          onClick={() => {
            setSearch(true)
          }} variant="contained">{
          (filters.startTime && filters.endTime) ? `${filters.startTime}~${filters.endTime}` : 'Date'
        }<RpIcon icon="arrow-down-simple" /></Button>
      </Stack>
      <Divider sx={{ borderColor: theme.palette.background.paper, borderWidth: '4px' }} />
      <Stack direction="column" sx={{flex: 1, overflow: 'auto', marginTop: '24px'}} ref={ref}>
        {loading ? (
          <Stack sx={{padding: '16px'}}>
            <TransItem/>
            <TransItem/>
            <TransItem/>
          </Stack>
        ) : list.length === 0 ? (
          <Box>
            <Empty text={t('empty_data')}/>
          </Box>
        ) : (
          <>
            <Box ref={wrapperRef}>
              {Object.keys(groupedList).map((key, idx) => {
                return (<>
                    <DayAssetsTransItem
                      key={key}
                      onClick={(item) => {
                        setCurrent(item)
                        navigate(`${RouteConstant.ASSETS_TRANS_DETAIL}?sn=${item.sn}`)
                      }}
                      dateText={key} list={groupedList[key]}/>
                  <Divider sx={{borderWidth: '4px'}}/>
                  </>

                )
              })}
            </Box>
            <Box style={{marginTop: 8}}>
              {(!isCompact && !loading && !noMore) && (
                <Box>
                  <LoadMore disabled={loadingMore} loading={loadingMore} hasMore={!noMore} onClick={() => {
                    // loadMore()
                  }}/>
                </Box>
              )}

              {(!loading && noMore) && <Typography align="center">{t('no_more_data')}</Typography>}
            </Box>
          </>

        )}

      </Stack>
      {/*{current && <AssetsTransDetail open={current} onClose={() => setCurrent(null)} sn={current.sn}/>}*/}
      <SearchItem open={search} onClose={() => setSearch(false)} onSearch={handleSearch}></SearchItem>
    </Stack>
  );
}
